import { FlowController } from "../../../game_theme/flow_fb/flowController";
import { tgfHooks } from "../../framework/hooks/hooks";
import { playController } from "../gameController";
export var AngryAnalytics = {
    /////
    getGameType: function () {
        var playController = this.getPlayController();
        if (!playController) {
            console.warn("Unable to get game type: Missing PlayController!");
            return "unknown_gametype";
        }
        return playController.gameType;
    },
    /////
    getContextType: function () {
        return tgfHooks.getContextType();
    },
    /////
    getPlayController: function () {
        return playController;
    },
    getMatchId: function () {
        if (this.getPlayController()) {
            return this.getPlayController().matchId.toString();
        }
    },
    getLevelId: function () {
        if (this.getPlayController()) {
            return this.getPlayController().levelIndex.toString();
        }
    },
    reportStartGame: function (gameStatus) {
        //AnalyticsService.reportProgression(AnalyticsProgressionStatus.Start, [this.getGameType(), gameStatus, this.getLevelId(), this.getMatchId(), AIController.getAILevel(this.getGameType())]);
    },
    reportGameStatus: function (hasWon, rank) {
        // var status = hasWon ? AnalyticsProgressionStatus.Complete : AnalyticsProgressionStatus.Fail;
        // var exp = hasWon ? ExpSettings.expGain.win : ExpSettings.expGain.loss;
        //AnalyticsService.reportProgression(status, [this.getGameType(), this.getLevelId(), this.getMatchId(), AIController.getAILevel(this.getGameType()), rank], exp);
    },
    reportSkillRank: function () {
        //AnalyticsService.reportDesignEvent(["skill_rank", AIController.getAnalyticsAILevel()]);
    },
    reportSwitching: function () {
        //AnalyticsService.reportDesignEvent(["context_switch"]);
    },
    reportClickEntry: function (entry, levelId, matchId) {
        var msgType = "";
        var inviteTag = null;
        var matildaTag = null;
        switch (entry) {
            case "custom_update":
                entry = "custom_share";
                msgType = "poke";
                break;
            case "custom_share":
                msgType = "end_of_game";
                break;
            case "gamebot0":
                entry = "gamebot";
                msgType = "reminder_1";
                break;
            case "gamebot1":
                entry = "gamebot";
                msgType = "reminder_2";
                break;
            case "gamebot2":
                entry = "gamebot";
                msgType = "reminder_3";
                break;
            case "gamebot3":
                entry = "gamebot";
                msgType = "reminder_4";
                break;
            case "gamebot4":
                entry = "gamebot";
                msgType = "reminder_5";
                break;
            case "gamebotGlobal":
                entry = "gamebot";
                msgType = "global";
                break;
            case "invite_01":
                msgType = "invite";
                inviteTag = "invite_01";
                entry = "custom_update";
                break;
            case "invite_02":
                msgType = "invite";
                inviteTag = "invite_02";
                entry = "custom_update";
                break;
            case "invite_03":
                msgType = "invite";
                inviteTag = "invite_03";
                entry = "custom_update";
                break;
            case "invite_01:matilda":
                msgType = "invite";
                inviteTag = "invite_01";
                entry = "custom_update";
                matildaTag = "matilda";
                break;
            case "invite_02:matilda":
                msgType = "invite";
                inviteTag = "invite_02";
                entry = "custom_update";
                matildaTag = "matilda";
                break;
            case "invite_03:matilda":
                msgType = "invite";
                inviteTag = "invite_03";
                entry = "custom_update";
                matildaTag = "matilda";
                break;
            case "turn":
                msgType = "turn";
                entry = "custom_update";
                break;
            case "group":
                msgType = "group";
                entry = "custom_update";
                break;
        }
        var payload = ["click", entry, msgType];
        if (inviteTag) {
            payload.push(inviteTag);
        }
        if (matildaTag) {
            payload.push(matildaTag);
        }
        if (levelId) {
            payload.push(levelId.toString());
        }
        if (matchId) {
            payload.push(matchId.toString());
        }
        //AnalyticsService.reportDesignEvent(payload);
    },
    reportOnBoardingTime: function (state, time) {
        var seconds = time / 1000;
        //AnalyticsService.reportDesignEvent(["onboarding", state], seconds);
    },
    /**
     * Reports the FBInstant loading is complete
     * @param {string} type
     * @param {number} loadtime
     */
    reportLoadComplete: function (type, loadtime) {
        var seconds = loadtime / 1000;
        //AnalyticsService.reportDesignEvent(["loading", type], seconds);
    },
    /**
     * Returns if the underlying analytics module is initialized
     * @returns {boolean}
     */
    isInitialized: function () {
        return; //AnalyticsService.isInitialized();
    },
    /**
     * Reports how long the Rovio screen is visible to the user
     * @param {number} duration
     */
    reportLegalScreenDuration: function (duration) {
        var seconds = duration / 1000;
        //AnalyticsService.reportDesignEvent(["screen", "legalscreen"], seconds);
    },
    reportScreen: function (screen, additionalEvent) {
        var payload = ["screen", screen];
        if (additionalEvent) {
            payload.push(additionalEvent);
        }
        //AnalyticsService.reportDesignEvent(payload);
    },
    /**
     * Reports how long the lobby takes to load REGARDLESS OF OUR THROTTLING (i.e. if it takes 340ms but we
     * show the loading screen for 2000ms, then this function should report 340ms)
     *
     * @param {number} duration
     */
    reportLobbyLoadTime: function (duration) {
        var seconds = duration / 1000;
        //AnalyticsService.reportDesignEvent(["screen", "lobby"], seconds);
    },
    reportUXButton: function (button) {
        //AnalyticsService.reportDesignEvent(["ux", button]);
    },
    reportUXButtonOpen: function (button) {
        //AnalyticsService.reportDesignEvent(["ux", button, "open"]);
    },
    reportUXButtonClose: function (button) {
        //AnalyticsService.reportDesignEvent(["ux", button, "close"]);
    },
    reportPlayerConfirm: function (origin) {
        //AnalyticsService.reportDesignEvent(["ux", origin, "confirm"]);
    },
    reportOptInTerms: function (action) {
        //AnalyticsService.reportDesignEvent(["ux", "opt_in", "view_details", action]);
    },
    reportRewardContinueAction: function (origin) {
        //AnalyticsService.reportDesignEvent(["ux", origin, "powerup", "continue"]);
    },
    reportContext: function () {
        //AnalyticsService.reportDesignEvent([this.getContextType()], tgfHooks.getContextID());
    },
    reportRequestedFacebookAdvertisement: function (hasSucceeded, entryPoint, adType) {
        var result = hasSucceeded ? "yes" : "no";
        var type = "";
        if (adType === FlowController.adTypes.REWARDED) {
            type = "rewarded_ad";
        }
        else if (adType === FlowController.adTypes.INTERSTITIAL) {
            type = "interstitial_ad";
        }
        else {
            throw new Error("Incorrect adType");
        }
        //AnalyticsService.reportDesignEvent(["fb_ads_watched", result, type, entryPoint, this.getGameType()]);
        if (hasSucceeded) {
            //AnalyticsService.reportAdImpressionEvent(AngryAnalytics.getRovioAdEntryPoint(type, entryPoint)); // exclusively for Rovio
        }
    },
    reportAdvertisementSupport: function (rewardedSupport, interstitialSupport) {
        var rewardedResult = rewardedSupport ? "yes" : "no";
        //AnalyticsService.reportDesignEvent(["supported_ads", rewardedResult, "rewarded_ad"]);
        var interstitialResult = interstitialSupport ? "yes" : "no";
        //AnalyticsService.reportDesignEvent(["supported_ads", interstitialResult, "interstitial_ad"]);
    },
    reportShareClicked: function () {
        //AnalyticsService.reportDesignEvent(["custom_share","end_of_game"]);
    },
    reportPokeClicked: function () {
        //AnalyticsService.reportDesignEvent(["custom_share","poke"]);
    },
    reportClickedRematchInResultScreen: function () {
        //AnalyticsService.reportDesignEvent(["endscreen", "rematch"]);
    },
    reportClickedLobbyInResultScreen: function () {
        //AnalyticsService.reportDesignEvent(["endscreen", "lobby"]);
    },
    reportAutomatedCustomMessages: function (isInvite, inviteTag) {
        var matchId = this.getMatchId();
        if (!isInvite && !matchId) {
            console.error("Analytics: matchid is invalid");
            return;
        }
        if (isInvite) {
            //AnalyticsService.reportDesignEvent(["custom_update", "invite", inviteTag]);
        }
        else {
            //AnalyticsService.reportDesignEvent(["custom_update", "turn", this.getGameType(), matchId, this.getLevelId()]);
        }
    },
    reportExpRankStatus: function (rank) {
        //AnalyticsService.reportDesignEvent(["xp_rank_status"], rank);
    },
    reportExpRankUpdate: function (rank) {
        //AnalyticsService.reportDesignEvent(["xp_rank_update"], rank);
    },
    reportInviteFriendsMessage: function (inviteTag, inviteNumber) {
        var inviteIndex = inviteNumber + 1;
        //AnalyticsService.reportDesignEvent(["custom_update", "invite", inviteTag, "matilda", inviteIndex.toString()]);
    },
    reportGroupCustomMessages: function () {
        //AnalyticsService.reportDesignEvent(["custom_update", "group"]);
    },
    getRovioAdEntryPoint: function (type, origin) {
        var result = (type === "rewarded_ad") ? 'RewardVideo' : 'InterstitialVideo';
        switch (origin) {
            case 'lobby':
                return (result += 'Lobby');
            case 'pre_game':
                return (result += 'PreGame');
            case 'end_screen':
                return (result += 'EndScreen');
            case 'powerup_bar':
                return (result += 'PowerUpBar');
            case 'mightyscope':
                return (result += 'MightyScope');
            default:
                return (result += 'Inventory');
        }
    },
    reportAdClickEvent: function (entryPoint) {
        // Not in use
        //AnalyticsService.reportAdClickEvent(AngryAnalytics.getRovioAdEntryPoint("", entryPoint));
    },
    reportAdShow: function (adType, entryPoint) {
        var payload = [];
        var type = "";
        if (adType === FlowController.adTypes.REWARDED) {
            payload = payload.concat(["rewarded_ad", "powerup"]);
            type = "rewarded_ad";
        }
        else if (adType === FlowController.adTypes.INTERSTITIAL) {
            payload = payload.concat(["interstitial_ad"]);
            type = "interstitial_ad";
        }
        else {
            throw new Error("Incorrect adType");
        }
        payload = payload.concat([entryPoint, this.getGameType()]);
        if (this.getLevelId()) {
            payload.push(this.getLevelId());
        }
        if (this.getMatchId()) {
            payload.push(this.getMatchId());
        }
        //AnalyticsService.reportDesignEvent(payload);
        //AnalyticsService.reportAdRequestEvent(AngryAnalytics.getRovioAdEntryPoint(type, entryPoint));
    },
    reportLobbyEntry: function (isNewGame, levelId, matchId) {
        var _isNewGame = isNewGame ? "new_game" : "existing_game";
        var payload = ["lobby", _isNewGame, this.getGameType()];
        if (levelId) {
            payload.push(levelId.toString());
        }
        if (matchId) {
            payload.push(matchId.toString());
        }
        //AnalyticsService.reportDesignEvent(payload);
    },
    fbEntryPoint: function (entrypoint) {
        //AnalyticsService.reportDesignEvent(["entry_point", entrypoint]);
    },
    reportEndedTurn: function () {
        //AnalyticsService.reportDesignEvent(["turn", this.getGameType(), this.getLevelId(), this.getMatchId()]);
    },
    reportPowerupType: function (powerType) {
        //AnalyticsService.reportDesignEvent(["powerup", powerType, this.getGameType(), this.getLevelId(), this.getMatchId()]);
    },
    reportMatchDuration: function (duration) {
        var seconds = duration / 1000;
        //AnalyticsService.reportDesignEvent(["match_duration"], seconds);
    },
    reportClickedLobbyDuringMatch: function () {
        //AnalyticsService.reportDesignEvent(["end_of_turn", "lobby"]);
    },
    reportClickedNextGameDuringMatch: function () {
        //AnalyticsService.reportDesignEvent(["end_of_turn", "existing_game"]);
    },
    reportClickedNewGameDuringMatch: function () {
        //AnalyticsService.reportDesignEvent(["end_of_turn", "new_game"]);
    },
    reportReplayHandling: function (didWatch) {
        var _didWatch = didWatch ? "watch" : "skip";
        //AnalyticsService.reportDesignEvent(["replay", _didWatch, this.getGameType(), this.getLevelId(), this.getMatchId()]);
    },
    reportScopeAdButtonPressed: function () {
        //AnalyticsService.reportDesignEvent(["ux", "mightyscope", "watch_ad"]);
    },
    reportScopeClose: function () {
        //AnalyticsService.reportDesignEvent(["ux", "mightyscope", "close"]);
    },
    reportScopeOpen: function () {
        //AnalyticsService.reportDesignEvent(["screen", "mightyscope", this.getGameType()]);
    },
    reportPreGamePowerupRefresh: function (powerupCount) {
        //AnalyticsService.reportDesignEvent(["ux", "refill_powerups", "start_game", this.getGameType()], powerupCount);
    },
    reportShot: function () {
        //AnalyticsService.reportDesignEvent(["interaction", "shot", this.getGameType(), this.getLevelId(), this.getMatchId()]);
    },
    reportPowerupTapped: function () {
        //AnalyticsService.reportDesignEvent(["interaction", "powerup", "tapped", this.getGameType(), this.getLevelId(), this.getMatchId()]);
    },
    reportPowerupUsed: function () {
        //AnalyticsService.reportDesignEvent(["interaction", "powerup", "used", this.getGameType(), this.getLevelId(), this.getMatchId()]);
    },
    reportCardChange: function (type) {
        //AnalyticsService.reportDesignEvent(["interaction", "card_change", type, this.getGameType(), this.getLevelId(), this.getMatchId()]);
    },
    reportConsoleMessage: function (severity, message) {
        //AnalyticsService.reportError(severity, message);
    },
    reportAdError: function (message) {
        //AnalyticsService.reportError(AnalyticsErrorSeverity.Error, "Ad Error: " + message);
    },
    reportDailyReward: function (day, cycle) {
        var dayString = "day_" + (day + 1);
        var payload = ["dailyreward", cycle, dayString];
        if (day == 4) {
            payload.push("terence");
        }
        //AnalyticsService.reportDesignEvent(payload);
    },
    reportMatildaReward: function () {
        //AnalyticsService.reportDesignEvent(["reward", "matilda", "unlocked"]);
    },
    reportDailyRewardCompleted: function (cycle) {
        //AnalyticsService.reportDesignEvent(["dailyreward", cycle, "completed"]);
    },
    reportDailyRewardReset: function (cycle) {
        //AnalyticsService.reportDesignEvent(["dailyreward", cycle, "reset"]);
    },
    reportGamebotOptInOpen: function () {
        //AnalyticsService.reportDesignEvent(["screen", "gamebot_optin"]);
    },
    reportGamebotOptInClose: function (accepted) {
        var acceptString = accepted ? "accept" : "decline";
        //AnalyticsService.reportDesignEvent(["ux", "gamebot_optin", acceptString]);
    },
};
